module.exports = __webpack_public_path__ + "img/1.3bbff4f1.jpg";